var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup950(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118.526,
    height: 100,
    viewBox: "0 0 118.526 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_947",
    "data-name": "Group 947",
    transform: "translate(457.41 -129.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4034",
    "data-name": "Path 4034",
    d: "M-416.726,148.4v7.393h-1.257q-12.095,0-24.19,0a7.408,7.408,0,0,0-7.836,7.824q-.005,25.521,0,51.042a7.41,7.41,0,0,0,7.844,7.819q44.039,0,88.078,0a7.407,7.407,0,0,0,7.8-7.746q.008-25.579,0-51.157a7.4,7.4,0,0,0-7.765-7.781q-14.063-.009-28.125,0h-1.106a16.2,16.2,0,0,1-2.353,7.911,14.886,14.886,0,0,1-15.5,6.612,14.79,14.79,0,0,1-11.625-12.3,18.309,18.309,0,0,1-.192-2.531q-.022-10.706-.007-21.412c0-2.744,1.46-4.193,4.221-4.194q10.59,0,21.181,0c2.743,0,4.212,1.467,4.214,4.205q.006,6.481,0,12.963V148.4h1.473q13.946,0,27.893,0a14.736,14.736,0,0,1,14.712,11.644,13.931,13.931,0,0,1,.354,3.089q.032,25.984.01,51.967A14.789,14.789,0,0,1-353.7,229.865q-44.443.019-88.887,0A14.789,14.789,0,0,1-457.4,215.094q-.023-25.984,0-51.967A14.788,14.788,0,0,1-442.666,148.4C-434.064,148.381-425.462,148.4-416.726,148.4Zm12.974,3.708a5.52,5.52,0,0,0,5.646,5.593,5.52,5.52,0,0,0,5.564-5.56,5.518,5.518,0,0,0-5.589-5.649A5.515,5.515,0,0,0-403.751,152.1Z",
    fill: "#D10A11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4035",
    "data-name": "Path 4035",
    d: "M-146.631,431.6H-182.2c1.066-6.351,7.24-13.385,16.54-13.865C-153.935,417.13-147.694,425.486-146.631,431.6Z",
    transform: "translate(-211.497 -221.195)",
    fill: "#D10A11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4036",
    "data-name": "Path 4036",
    d: "M-358.915,385.874q7.229,0,14.458,0a3.748,3.748,0,0,1,4.058,3.661,3.73,3.73,0,0,1-3.993,3.727q-14.516.01-29.031,0c-2.891,0-4.746-2.546-3.732-5.073a3.73,3.73,0,0,1,3.667-2.313Q-366.2,385.865-358.915,385.874Z",
    transform: "translate(-61.46 -196.733)",
    fill: "#D10A11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4037",
    "data-name": "Path 4037",
    d: "M-360.724,337.874q6.3,0,12.607,0a3.747,3.747,0,0,1,4.061,3.658c.023,2.178-1.674,3.731-4.1,3.732q-12.549.006-25.1,0c-2.438,0-4.131-1.539-4.117-3.719s1.693-3.669,4.159-3.672Q-366.97,337.869-360.724,337.874Z",
    transform: "translate(-61.507 -159.845)",
    fill: "#D10A11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4038",
    "data-name": "Path 4038",
    d: "M-132.321,351.07a8.1,8.1,0,0,1-8.06-8.1,8.094,8.094,0,0,1,8.187-8.088,8.1,8.1,0,0,1,8,8.157A8.1,8.1,0,0,1-132.321,351.07Z",
    transform: "translate(-243.636 -157.546)",
    fill: "#D10A11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4039",
    "data-name": "Path 4039",
    d: "M-364.587,441.265c-2.929,0-5.859.007-8.788,0a3.737,3.737,0,0,1-4-3.72,3.729,3.729,0,0,1,4.043-3.669q8.9-.009,17.807,0a3.747,3.747,0,0,1,4.06,3.658c.02,2.181-1.673,3.727-4.1,3.732C-358.574,441.27-361.58,441.265-364.587,441.265Z",
    transform: "translate(-61.507 -233.618)",
    fill: "#D10A11"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup950);
export default __webpack_public_path__ + "static/media/Group 950.e207b96d144fc02e922897b174137f91.svg";
export { ForwardRef as ReactComponent };